var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 65,
    viewBox: "0 0 88 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.2041C3.36732 34.7007 6.62811 32.2211 9.94808 29.8366C11.1849 28.9506 12.1022 28.9625 13.0432 30.6572C16.1264 36.1932 19.4582 41.5983 22.7249 47.0332C23.2102 47.8419 23.8671 48.5495 24.7193 49.6615C26.2698 48.056 27.7848 46.7002 29.0512 45.1423C38.159 33.999 47.2075 22.8082 56.2916 11.647C59.2269 8.03765 62.1622 4.43421 65.1863 0.902134C65.636 0.372917 66.7249 -0.150355 67.2812 0.0399257C73.6016 2.16869 80.0818 3.34605 86.7099 3.8277C86.9821 3.84553 87.2543 3.91689 88 4.0477C86.0589 5.67103 84.3605 7.02084 82.7449 8.45388C76.6257 13.8828 70.4177 19.2107 64.4702 24.8239C59.2802 29.7177 54.2144 34.778 49.4268 40.0642C44.2308 45.8023 39.4136 51.8794 34.4425 57.8197C33.4956 58.9495 32.4304 60.0258 31.6966 61.2924C29.1518 65.6866 22.4172 66.6559 18.4699 61.5599C12.552 53.9309 6.65178 46.278 0.757498 38.6371C0.585877 38.4111 0.485272 38.1317 0 37.2041V37.2041Z",
    fill: "#2CDD73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/successCheck.5c258a50.svg";
export { ForwardRef as ReactComponent };